import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            实时热度
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            综艺热度榜
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            全网综艺实时热度排行，发现大家都在追的综艺
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="bg-background-50 rounded-xl p-5 border border-background-200/70 flex items-center gap-4 hover:border-primary-200 transition-colors group"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center text-base font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 font-medium whitespace-nowrap flex-shrink-0">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-accent-500"></i>
                    {item.heat}热度
                  </span>
                  <span
                    className={`font-medium ${
                      item.trend === 'up' ? 'text-green-600' : 'text-red-500'
                    }`}
                  >
                    {item.change}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <button className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            查看完整榜单
            <i className="ri-arrow-right-line ml-1"></i>
          </button>
        </div>
      </div>
    </section>
  );
}